let webApplicationStructuredData = {
  "@context": "https://schema.org",
  "@type": "WebApplication",
  name: "Content Generator",
  url: "https://contentgenerator.io",
  applicationCategory: "DesignApplication",
  operatingSystem: "Any",
  browserRequirements: ["requires HTML5 support", "requires JavaScript"],
  permissions: "may run only with an active internet connection",
  description:
    "Speed up your marketing with Content Generator. Create Social Media posts in seconds with our easy-to-use post design tool. Generate and schedule posts, optimize your SEO, and more.",
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.6",
    ratingCount: "539",
  },
  screenshot: "https://contentgenerator.io/cg-screenshot.webp",
};

function getBlogPostCardSchema(post, relPostLink) {
  let blogPostSchema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: post.title.rendered,
    description: post.yoast_head_json.description,
    thumbnailUrl: post.yoast_head_json.og_image
      ? post.yoast_head_json.og_image[0].url
      : "",
    datePublished: post.yoast_head_json.article_published_time,
    dateModified: post.yoast_head_json.article_modified_time,
    url: `https://contentgenerator.io${relPostLink}`,
    author: post.yoast_head_json.author,
    image: post.yoast_head_json.og_image
      ? post.yoast_head_json.og_image[0].url
      : "",
  };

  return blogPostSchema;
}

function getSingleBlogPostSchema(blogPostData) {
  let blogPostSchema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: blogPostData.title,
    datePublished: blogPostData.date,
    description: blogPostData.description,
    thumbnailUrl: blogPostData.ogImage,
    url: blogPostData.url,
    image: blogPostData.ogImage,
  };

  return blogPostSchema;
}

function getReviewSchema(name, stars, text) {
  let reviewSchema = {
    "@context": "https://schema.org",
    "@type": "Review",
    itemReviewed: {
      "@type": "WebApplication",
      name: "Content Generator ",
      url: "https://contentgenerator.io",
      operatingSystem: "All",
      applicationCategory: "DesignApplication",
    },
    author: {
      "@type": "Person",
      name: name,
    },
    reviewRating: {
      "@type": "Rating",
      ratingValue: stars,
      bestRating: 5,
      worstRating: 1,
    },
    reviewBody: text,
  };

  return reviewSchema;
}

function getSinglePageSchema(pageData) {
  console.log("PAGE DATA: ", pageData);

  let singlePageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: pageData.title,
    description: pageData.description,
    url: pageData.url,
    thumbnailUrl: pageData.ogImage,
    datePublished: pageData.datePublished + "Z",
    dateModified: pageData.dateModified + "Z",
  };

  return singlePageSchema;
}

module.exports = {
  name: "Content Generator",
  url: "https://contentgenerator.io",
  description:
    "Speed up your marketing with Content Generator. Create Social Media posts in seconds with our easy-to-use post design tool. Generate and schedule posts, optimize your SEO, and more.",
  webApplicationStructuredData,
  getBlogPostCardSchema,
  getSingleBlogPostSchema,
  getReviewSchema,
  getSinglePageSchema,
};
